function GoogleRecaptcha(): Promise<typeof grecaptcha> {
  const recaptcha: typeof grecaptcha = window.grecaptcha;
  if (!process.env.GOOGLE_CLIENT_RECAPTCHA)
    throw new Error('No google recaptcha');
  if (recaptcha) {
    return Promise.resolve(recaptcha);
  }
  return new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(
      'script[src*="recaptcha/enterprise.js"]',
    );

    if (existing) {
      existing.addEventListener('load', () => {
        resolve(window.grecaptcha);
      });

      return;
    }

    const script = document.createElement('script');

    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${process.env.GOOGLE_CLIENT_RECAPTCHA}&hl=sv`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve(window.grecaptcha);
    script.onerror = reject;

    document.body.appendChild(script);
  });
}

export default GoogleRecaptcha;
